<svelte:options accessors={true}/>
<script>
    import HRImport from './../../components/HR/HRImport.svelte';
	import JobRoles from './../../components/HR/JobRoles.svelte';
    import { onMount } from 'svelte';
    import ReportsService from "../../services/reports.service";
    import HRService from '../../services/hr.service.js';
    import AuthService from '../../services/auth.service.js';
    import Loader from "../../components/Loader.svelte";
    import EditableCell from "../../components/EditableCell.svelte";
    import ExportService from '../../services/export.service'
    import { formatValue, cleanValue } from '../../helpers/format.helper';

    let page, loading = false, reportData;
    let yearlyHeadCount;
    let months = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
    export let user, params, loadingExport = false;

    $: loadData(params);
    $: reportData;
    onMount(() => {
        loadData();
    });

    async function loadData() {
        if (loading) return;
        loading = true;
        reportData = null;
        setDefaultHeadCounts();
        const url = '/org/' + params.org + '/hr_staffing_budgets/date/' + params.year ;
        let result = null;

        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) reportData = result.data;
        getHeadCounts();
        fillStaff();
        loading = false;

        setTimeout(() => {
            tablesLoaded(true);
            enableTableSelection();
        }, 1000);
    }

    export const exportToExcel = async () => {
        loadingExport = true;
        try {
            const url = `/org/${params.org}/export/hr_staffing_budgets/date/${params.year}`;
            const staffingBudgetReport = (await ReportsService.load(url)).data;

            const isFacilitator = !AuthService.can('EXPORT_HR_ALL_PORTCOS');
            const fileName = (!isFacilitator)? 'HR-Staffing-budget':`HR-Staffing-budget-${jQuery('#dropdownOrganizations').text()}`;

            await ExportService.downloadStaffingBudget(
                staffingBudgetReport,
                yearlyHeadCount,
                fileName,
                params.year,
                isFacilitator,
            );
        } catch (e) {
            console.log('Error', e);
        } finally {
            loadingExport = false;
        }
    };


    async function saveStaffingBudgetStaffData(value, id, field, staffKey){
        if(jQuery('.hr-pasting').length > 0){
            //Avoid save all the string pasted on the selected cell
            return false;
        }
        try {
            let staff = reportData.staff[staffKey];
            let staffingResult = null;
            if(field == 'department'){
                getHeadCounts();
            }
            staffingResult = await ReportsService.saveStaffingBudgetStaffData({value, organization_id: params.org, id: staff.id, field, year : params.year});
            if (staffingResult && staffingResult.data){
                if(!staff.id){
                    reportData.staff[staffKey].id = await staffingResult.data.id;
                    setTimeout(() => {
                        enableTableSelection();
                    }, 500);
                }
            }
        } catch (e) {
            console.log('Error', e);
        }
    }

    let saveStaffingBudgetData = async function(staffing_budget_staff_id, date, value, staffIndex) {
        if(jQuery('.hr-pasting').length > 0){
            // Avoid save all the string pasted on the selected cell
            return false;
        }
        reportData.staff[staffIndex][date] = value;
        getHeadCounts();
        await ReportsService.saveStaffingBudget({ staffing_budget_staff_id, date, value });
    }

    let openJobRolesModal = function(){
        jQuery('#jobRolesModal').modal('show');
    }


    function setDefaultHeadCounts(){
        yearlyHeadCount = {
            "Marketing": [0,0,0,0,0,0,0,0,0,0,0,0],
            "Sales": [0,0,0,0,0,0,0,0,0,0,0,0]
        }
    }

    function getHeadCounts(){
        setDefaultHeadCounts();
        reportData.staff.forEach((staff, staffIndex) => {
            let index = 0;
            Object.keys(staff).sort().forEach((element,key) => {
                if(key < 12){
                    //It's a date field
                    if(staff[element] && !isNaN(staff[element])){
                        if(['Sales','Marketing'].includes(staff.department)){
                            yearlyHeadCount[staff.department][index]+= parseInt(staff[element]);
                        }
                    }
                    index++;
                }
            });
        });
    }

    function fillStaff(){
        const staffToAdd = 150 - reportData.staff.length;
        for (let index = 0; index < staffToAdd; index++) {
            reportData.staff.push({
                id: null,
                employee_name: "",
                job_role: "",
                department: "",
                year: params.year
            })
        }
    }

    //Import
    export const openImportModal = function(){
        jQuery('#importModal').modal('show');
    }

    let onImported = async function(){
        jQuery('#importModal').modal('hide');
        await loadData();
    }
</script>


{#if loading}
    <Loader></Loader>
{:else}
    {#if AuthService.can('IMPORT_HR_REPORTS') }
        <HRImport params={params} module="staffing_budget" on:imported={onImported}></HRImport>
    {/if}
    <JobRoles></JobRoles>
    <button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>
    <!-- Hiring plns -->
    <div class="table-wrapper mb-3">
        <table class="table table-sm container-fluid selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                    <th class="col-header text-center" id="headcounts-budget">Budget</th>
                    {#each months as month}
                        <th class="col-subheader">{month + "/" + params.year}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each Object.keys(yearlyHeadCount) as headCountType}
                    <tr>
                        <td class="readOnly">{headCountType}</td>
                        {#each yearlyHeadCount[headCountType] as headCount}
                            <td class="readOnly">{headCount}</td>
                        {/each}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>

    <!-- Staff plan -->
    <div class="table-wrapper mb-3 hr-report staffing-budget">
        <table class="table table-sm container-fluid selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                    <th class="col-subheader staffing_budget-name">Employee Name</th>
                    <th class="col-subheader staffing_budget-job_role">
                        Job Role
                        <i
                            class="fa fa-info-circle ml-2 vertical-middle pointer"
                            on:click={ openJobRolesModal }
                        ></i>
                    </th>
                    <th class="col-subheader staffing_budget-department">Sales / Marketing</th>
                    {#each reportData.headers.staff as key}
                        <th class="col-subheader notFixed w-auto">{key}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each reportData.staff as staff, rowIndex}
                    <tr>
                        <th>
                            <EditableCell
                                id="t2-{rowIndex+"-0"}"
                                bind:value={staff.employee_name}
                                on:change={(e) => saveStaffingBudgetStaffData(e.detail.value, staff.id, 'employee_name', rowIndex)}
                                format={7}
                                hrData="{ {staffing_budget_staff_id: staff.id, key: 'employee_name', model: 'staffing_budget_staff', year: params.year, format: 7} }"
                                customClass="hr-cell text-left"
                                type="text"
                                ></EditableCell>
                        </th>
                        <th>
                            <EditableCell
                                id="t2-{rowIndex+"-1"}"
                                bind:value={staff.job_role}
                                type="select"
                                customClass="hr-cell"
                                selectOptions={reportData.headers.job_roles}
                                on:change={(e) => saveStaffingBudgetStaffData(e.detail.value, staff.id, 'job_role', rowIndex)}
                                hrData="{ {staffing_budget_staff_id: staff.id, key: 'job_role', model: 'staffing_budget_staff', year: params.year, format: 7} }"
                                ></EditableCell>
                        </th>
                        <th>
                            <EditableCell
                                id="t2-{rowIndex+"-2"}"
                                bind:value={staff.department}
                                type="select"
                                customClass="hr-cell"
                                selectOptions={ reportData.headers.departments }
                                on:change={(e) => saveStaffingBudgetStaffData(e.detail.value, staff.id, 'department', rowIndex)}
                                hrData="{ {staffing_budget_staff_id: staff.id, key: 'department', model: 'staffing_budget_staff', year: params.year, format: 7} }"
                                format={7}></EditableCell>
                        </th>

                        {#each reportData.headers.staff as key, columnIndex}
                            {#if AuthService.can('EDIT_CELL') && staff.id}
                                <td class="notFixed w-auto">
                                    <EditableCell
                                        id="t2-{rowIndex+"-"+(columnIndex+3)}"
                                        bind:value={staff[key]}
                                        customClass="hr-cell text-center"
                                        on:change={(e) => saveStaffingBudgetData(staff.id, key, e.detail.value, rowIndex)}
                                        hrData="{ {staffing_budget_staff_id: staff.id, key: key, model: 'staffing_budget_data', year: params.year, format: 7} }"
                                        format={0}></EditableCell>
                                </td>
                            {:else}
                                <td class="notFixed readOnly w-auto">{0}</td>
                            {/if}
                        {/each}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}
